import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const services = [
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    ),
    title: 'Web Development',
    description: 'Responsive websites and powerful web applications built for Dubai businesses — from corporate portals to e-commerce platforms.',
    href: '/services/web-development',
    gradient: 'from-blue-500 to-cyan-500'
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Mobile App Development',
    description: 'Native iOS and Android apps, and cross-platform solutions engineered for the UAE market and beyond.',
    href: '/services/mobile-app-development',
    gradient: 'from-purple-500 to-pink-500'
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Custom Software Development',
    description: 'Bespoke enterprise software tailored to your exact business requirements — ERP, CRM, POS, HRM, and more.',
    href: '/services/custom-software-development',
    gradient: 'from-cyan-500 to-blue-600'
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
    title: 'Cloud Solutions',
    description: 'Cloud migration, managed infrastructure, AWS & Azure deployment, and scalable cloud architecture for Dubai enterprises.',
    href: '/services/cloud-solutions',
    gradient: 'from-green-500 to-teal-500'
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'Data Analytics',
    description: 'Turn raw business data into strategic intelligence — dashboards, BI platforms, and predictive analytics for smarter decisions.',
    href: '/services/data-analytics',
    gradient: 'from-indigo-500 to-purple-500'
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
      </svg>
    ),
    title: 'UI/UX Design',
    description: 'Intuitive, visually stunning interfaces that convert — product design, prototyping, and user research for UAE digital products.',
    href: '/services/ui-ux-design',
    gradient: 'from-orange-500 to-red-500'
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
      </svg>
    ),
    title: 'DevOps & AWS Services',
    description: 'CI/CD pipelines, infrastructure automation, containerisation, and 24/7 cloud operations for business-critical systems.',
    href: '/services/devops-aws-services',
    gradient: 'from-slate-600 to-blue-600'
  }
];

const industries = [
  { icon: '🏨', name: 'Hospitality & Tourism', desc: 'Hotel management systems, booking platforms, guest experience apps' },
  { icon: '🛒', name: 'Retail & E-Commerce', desc: 'Multi-vendor marketplaces, POS systems, inventory management' },
  { icon: '🏥', name: 'Healthcare', desc: 'Patient portals, clinic management, telemedicine platforms' },
  { icon: '🍽️', name: 'Food & Beverage', desc: 'Restaurant POS, kitchen display systems, delivery management' },
  { icon: '🚚', name: 'Logistics & Supply Chain', desc: 'Fleet tracking, warehouse management, route optimization' },
  { icon: '🏦', name: 'Finance & Banking', desc: 'Fintech apps, payment gateways, compliance automation' },
  { icon: '🏗️', name: 'Real Estate', desc: 'Property portals, CRM solutions, virtual tour platforms' },
  { icon: '📚', name: 'Education & Training', desc: 'LMS platforms, e-learning apps, student management systems' }
];

const faqs = [
  {
    q: 'How long does it take to develop a custom software solution in Dubai?',
    a: 'Timelines vary by complexity. A basic web application typically takes 6–12 weeks. Enterprise systems like ERP or CRM can take 3–6 months. We provide a detailed project plan during discovery so you have a clear timeline before we start.'
  },
  {
    q: 'Do you work with both SMEs and large enterprises in the UAE?',
    a: 'Yes. We serve businesses of all sizes across Dubai and the UAE — from startups building their first product to established enterprises modernising legacy systems. Our solutions scale with your business.'
  },
  {
    q: 'Can you integrate software with UAE-specific payment gateways and compliance requirements?',
    a: 'Absolutely. We have experience integrating with UAE payment gateways (PayFort, Network International, Telr) and ensuring compliance with UAE data protection and financial regulations.'
  },
  {
    q: 'Do you provide post-launch support and maintenance?',
    a: 'Yes. All our projects come with a warranty period and we offer flexible SLA-based support packages — from basic monitoring to full managed services with 24/7 response.'
  },
  {
    q: 'Can you build bilingual (Arabic/English) applications?',
    a: 'Yes. We build fully RTL-compatible, bilingual applications in Arabic and English, following UAE market requirements for both UX design and content structure.'
  },
  {
    q: 'What technologies do you use for software development in Dubai?',
    a: 'Our stack includes React, Next.js, Node.js, .NET, Flutter, React Native, AWS, Azure, PostgreSQL, SQL Server, and more. We choose the right technology for each project rather than forcing a one-size-fits-all approach.'
  }
];

const stats = [
  { number: '500+', label: 'Projects Delivered', icon: '🚀' },
  { number: '200+', label: 'Happy Clients', icon: '❤️' },
  { number: '8+', label: 'Years in UAE', icon: '📍' },
  { number: '50+', label: 'Tech Experts', icon: '👥' }
];

const DubaiLandingPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    document.title = "Software Development Company Dubai | Custom Software Solutions UAE | Ascali";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Ascali is a leading software development company in Dubai delivering custom software solutions, web applications, mobile apps, cloud services, and business technology solutions for companies across the UAE.";
  }, []);

  useEffect(() => {
    const fallback = setTimeout(() => setIsVisible(true), 120);
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { clearTimeout(fallback); setIsVisible(true); } },
      { threshold: 0.05 }
    );
    if (contentRef.current) observer.observe(contentRef.current);
    return () => {
      clearTimeout(fallback);
      if (contentRef.current) observer.unobserve(contentRef.current);
    };
  }, []);

  return (
    <>
      <title>Software Development Company Dubai | Custom Software Solutions UAE | Ascali</title>
      <meta name="description" content="Ascali is a leading software development company in Dubai delivering custom software solutions, web applications, mobile apps, cloud services, and business technology solutions for companies across the UAE." />
      <Header />

      {/* Hero */}
      <section className="relative pt-32 pb-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 right-1/4 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl"></div>
          <div className="absolute inset-0 opacity-5"
            style={{
              backgroundImage: 'linear-gradient(rgba(96,165,250,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(96,165,250,0.4) 1px, transparent 1px)',
              backgroundSize: '50px 50px'
            }}>
          </div>
        </div>
        <div className="container-custom relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-6">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              <span className="text-white/90 text-sm font-medium">Based in Dubai, UAE · Serving the GCC Region</span>
            </div>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Software Development<br />
              <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                Company in Dubai
              </span>
            </h1>
            <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed mb-10">
              Ascali builds custom software, web and mobile applications, cloud infrastructure, and enterprise IT solutions for businesses across Dubai, Abu Dhabi, and the wider UAE — with 8+ years of proven delivery.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact-us"
                className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/40 hover:scale-105"
              >
                Get a Free Consultation
              </Link>
              <Link
                to="/services"
                className="bg-white/10 backdrop-blur-md border-2 border-white/20 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 hover:bg-white/20 hover:scale-105"
              >
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-white border-b border-slate-100 py-8">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-3xl mb-1">{stat.icon}</div>
                <div className="font-display text-3xl font-bold text-slate-900">{stat.number}</div>
                <div className="text-slate-500 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div ref={contentRef}>
        {/* Why Choose Ascali */}
        <section className="section-padding bg-slate-50">
          <div className="container-custom">
            <div className={`text-center mb-14 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <span className="inline-block text-blue-600 text-xs font-semibold uppercase tracking-widest mb-3 bg-blue-50 px-4 py-1.5 rounded-full">
                Why Ascali
              </span>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
                Dubai Businesses Trust <span className="gradient-text">Ascali</span>
              </h2>
              <p className="text-slate-600 text-lg max-w-2xl mx-auto leading-relaxed">
                We combine deep technical expertise with on-the-ground UAE market knowledge to deliver software that works — on time and within budget.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  icon: '📍',
                  title: 'Dubai-Based Team',
                  desc: 'Our delivery team operates from Dubai, giving you direct access and real-time collaboration in your timezone.'
                },
                {
                  icon: '🏆',
                  title: '8+ Years UAE Experience',
                  desc: 'Deep experience with UAE regulations, bilingual (Arabic/English) requirements, and local payment gateways.'
                },
                {
                  icon: '⚡',
                  title: 'Agile Delivery',
                  desc: 'Iterative sprints with regular demos keep you in control. No surprises, just consistent progress.'
                },
                {
                  icon: '🔐',
                  title: 'Enterprise-Grade Security',
                  desc: 'Every solution is built with security-first architecture aligned to UAE data protection requirements.'
                },
                {
                  icon: '🌐',
                  title: 'Full-Stack Capability',
                  desc: 'From UI/UX design to backend, cloud, and mobile — one partner for your entire technology stack.'
                },
                {
                  icon: '🤝',
                  title: 'Post-Launch Support',
                  desc: 'SLA-backed maintenance, monitoring, and continuous improvement so your software never stands still.'
                }
              ].map((item, i) => (
                <div
                  key={i}
                  className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg border border-slate-100 transition-all duration-300 hover:-translate-y-1 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
                  style={{ animationDelay: `${i * 0.08}s` }}
                >
                  <div className="text-3xl mb-4">{item.icon}</div>
                  <h3 className="font-display font-bold text-lg text-slate-900 mb-2">{item.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className={`text-center mb-14 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <span className="inline-block text-blue-600 text-xs font-semibold uppercase tracking-widest mb-3 bg-blue-50 px-4 py-1.5 rounded-full">
                Our Services
              </span>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
                IT Services for <span className="gradient-text">Dubai Businesses</span>
              </h2>
              <p className="text-slate-600 text-lg max-w-2xl mx-auto leading-relaxed">
                From concept to deployment, we cover the full technology spectrum your business needs to compete in the UAE market.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {services.map((svc, i) => (
                <Link
                  key={i}
                  to={svc.href}
                  className={`group bg-slate-50 hover:bg-white rounded-2xl p-6 border border-slate-100 hover:border-blue-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
                  style={{ animationDelay: `${i * 0.07}s` }}
                >
                  <div className={`w-14 h-14 bg-gradient-to-br ${svc.gradient} rounded-xl flex items-center justify-center text-white mb-5 group-hover:scale-110 transition-transform duration-300`}>
                    {svc.icon}
                  </div>
                  <h3 className="font-display font-bold text-base text-slate-900 mb-2 group-hover:text-blue-600 transition-colors">{svc.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed mb-4">{svc.description}</p>
                  <span className="text-blue-600 text-xs font-semibold group-hover:underline">Learn more →</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Industries */}
        <section className="section-padding bg-slate-50">
          <div className="container-custom">
            <div className={`text-center mb-14 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <span className="inline-block text-blue-600 text-xs font-semibold uppercase tracking-widest mb-3 bg-blue-50 px-4 py-1.5 rounded-full">
                Industries
              </span>
              <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Sectors We Serve <span className="gradient-text">Across the UAE</span>
              </h2>
              <p className="text-slate-600 text-lg max-w-2xl mx-auto">
                We have delivered software solutions across the most competitive industries in the Dubai market.
              </p>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {industries.map((ind, i) => (
                <div
                  key={i}
                  className={`bg-white rounded-2xl p-6 border border-slate-100 hover:border-blue-200 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
                  style={{ animationDelay: `${i * 0.07}s` }}
                >
                  <div className="text-3xl mb-3">{ind.icon}</div>
                  <h3 className="font-bold text-slate-900 mb-2 text-sm">{ind.name}</h3>
                  <p className="text-slate-500 text-xs leading-relaxed">{ind.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className={`text-center mb-14 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <span className="inline-block text-blue-600 text-xs font-semibold uppercase tracking-widest mb-3 bg-blue-50 px-4 py-1.5 rounded-full">
                How We Work
              </span>
              <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Our <span className="gradient-text">Delivery Process</span>
              </h2>
              <p className="text-slate-600 text-lg max-w-2xl mx-auto">
                A proven, transparent 5-stage process that has delivered 500+ projects for Dubai and UAE businesses.
              </p>
            </div>
            <div className="grid md:grid-cols-5 gap-6">
              {[
                { step: '01', title: 'Discovery', desc: 'We map your requirements, users, and business goals', icon: '🔍' },
                { step: '02', title: 'Design', desc: 'UI/UX wireframes and prototypes you approve before development', icon: '🎨' },
                { step: '03', title: 'Develop', desc: 'Agile sprints with weekly demos and full code ownership', icon: '💻' },
                { step: '04', title: 'Deploy', desc: 'Rigorous QA, UAT, and production launch with zero downtime', icon: '🚀' },
                { step: '05', title: 'Support', desc: 'SLA-backed maintenance, monitoring, and ongoing improvements', icon: '🛡️' }
              ].map((step, i) => (
                <div
                  key={i}
                  className={`text-center ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <div className="relative inline-block mb-4">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl flex items-center justify-center text-2xl mx-auto">
                      {step.icon}
                    </div>
                    <span className="absolute -top-2 -right-2 w-6 h-6 bg-slate-900 text-white text-xs font-bold rounded-full flex items-center justify-center">
                      {i + 1}
                    </span>
                  </div>
                  <h3 className="font-bold text-slate-900 mb-2">{step.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="section-padding bg-slate-50">
          <div className="container-custom">
            <div className={`text-center mb-14 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <span className="inline-block text-blue-600 text-xs font-semibold uppercase tracking-widest mb-3 bg-blue-50 px-4 py-1.5 rounded-full">
                FAQ
              </span>
              <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Common Questions About <span className="gradient-text">Software Development in Dubai</span>
              </h2>
            </div>
            <div className="max-w-3xl mx-auto space-y-4">
              {faqs.map((faq, i) => (
                <div
                  key={i}
                  className={`bg-white rounded-2xl border border-slate-100 overflow-hidden ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
                  style={{ animationDelay: `${i * 0.07}s` }}
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left"
                  >
                    <span className="font-semibold text-slate-900 pr-4 text-sm md:text-base">{faq.q}</span>
                    <svg
                      className={`w-5 h-5 text-blue-500 flex-shrink-0 transition-transform duration-200 ${openFaq === i ? 'rotate-180' : ''}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFaq === i && (
                    <div className="px-6 pb-5 text-slate-600 text-sm leading-relaxed border-t border-slate-100 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="section-padding bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600">
          <div className="container-custom text-center text-white">
            <div className={`max-w-3xl mx-auto ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
                Ready to Build Something Great?
              </h2>
              <p className="text-white/80 text-lg mb-10 leading-relaxed">
                Talk to our Dubai-based technology consultants today. We'll scope your project, suggest the right approach, and give you a transparent proposal — with no obligation.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/contact-us"
                  className="bg-white text-blue-600 px-10 py-4 rounded-xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300"
                >
                  Get a Free Consultation
                </Link>
                <Link
                  to="/services"
                  className="border-2 border-white/40 text-white px-10 py-4 rounded-xl font-semibold text-lg hover:bg-white/10 hover:border-white transition-all duration-300"
                >
                  View All Services
                </Link>
              </div>
              <div className="mt-10 flex flex-wrap justify-center gap-6 text-white/70 text-sm">
                <span className="flex items-center gap-2"><span className="text-green-400">✓</span> Free project scoping</span>
                <span className="flex items-center gap-2"><span className="text-green-400">✓</span> Transparent pricing</span>
                <span className="flex items-center gap-2"><span className="text-green-400">✓</span> No lock-in contracts</span>
                <span className="flex items-center gap-2"><span className="text-green-400">✓</span> Dubai-based team</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default DubaiLandingPage;
